<template>
  <modal :value="value"
         content-class="partner-manager-modal modal-device modal-overflow"
         content-overflow
         @input="emitInput">

    <div class="partner-manager-modal-body">
      <div class="partner-manager-modal-body-header">
        <h1 class="partner-manager-modal-body-title">{{$t('message.admEstablishments.message.partnerManagement')}}</h1>
      </div>

      <div style="display:flex;justify-content: center;align-items: center;width:100%;">
        <app-select v-model="selectedItemId"
                    :data-title="$t('message.admGenerics.message.partner')"
                    :data-menu-heading="$t('message.admGenerics.message.partner')"
                    data-menu-width="490px"
                    data-menu-height="300px"
                    :data-button-gradient="true"
                    :data-items="partnersList"
                    :no-results="noResults"
                    @input="changePartner" 
                    @search="v => search(v)"/>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@components/generic/Modal.vue";
import AppSelect from "@components/Select";
import EventBus from "@packages/event-bus/index";

export default {
  components: {
    AppSelect,
    Modal,
  },
  data() {
    return {
      list: [],
      selectedItemId: null,
      filteredList: [],
      searchedText: undefined,
      noResults: false
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: false,
    },
  },
  computed: {
    partnersList() {
      return this.filteredList.length > 0 ? this.filteredList : this.list
    }
  },
  methods: {
    emitInput(val) {
      this.$emit("input", val);
    },
    hideModal() {
      this.$emit("input", false);
    },
    changePartner(param) {
      this.changePartnerReq(param);
    },
    async changePartnerReq(partnerId) {
      try {
        if (partnerId) {
          await this.$api.establishments.linkPartner({
            partnerId,
            establishmentId: this.item.id,
          });
        } else {
          await this.$api.establishments.removePartner({
            establishmentId: this.item.id,
          });
        }

        EventBus.$emit("LOAD_DATA", "");

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: this.$t('message.successMessages.message.modificationCompleted'),
          timeout: 2000,
        });
      } catch (error) {
        console.log(error);
      }
    },
    search(search) {
      if(!search) {
        this.noResults = false
      }
      this.searchedText = search
      this.filteredList = this.list.filter(item => item.label.toLowerCase().includes(search.toLowerCase()))
      if(this.filteredList.length < 1)
        this.noResults = true
    },
    async getPartnersList() {
      try {
        const partners = await this.$api.establishments.listPartners();

        this.list = [...partners];        
      } catch (error) {
        console.log(error)
      }      
    },
  }, 

  async mounted() {
    await this.getPartnersList()
    this.selectedItemId = this.item && this.item.idPartner;
  },  
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.partner-manager-modal {
  .partner-manager-modal-body {
    padding: 20px 20px;

    .partner-manager-modal-body-title {
      text-align: center;
      font-size: 30px;
      font-weight: 600;
      margin-top: 0;
      margin-bottom: 40px;
      line-height: 1.1;
    }

    .partner-manager-modal-body-item {
      text-align: center;
      font-weight: 600;
      margin: 0;
    }

    .partner-manager-modal-body-summary {
      display: flex;
      gap: 40px;

      .partner-manager-modal-body-summary-item {
        flex: 1;
        text-align: center;
        border: 1px solid $color-muted;
        border-radius: 20px;
        padding: 10px;

        .partner-manager-modal-body-summary-item-title {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 10px;
          color: rgba(#4d4f5c, 0.5);
        }

        .partner-manager-modal-body-summary-item-text {
          margin: 0;
          color: #4d4f5c;
          font-size: 16px;
          font-weight: 600;
        }

        .partner-manager-modal-body-summary-item-loading {
          margin-bottom: 20px;
        }
      }
    }

    .partner-manager-modal-body-credits {
      margin: 30px 0;
      max-height: 300px;
      overflow-y: scroll;
    }

    .partner-manager-modal-body-actions {
      display: flex;
      justify-content: space-between;

      .btn {
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
